module.exports = __webpack_public_path__ + "static/media/manager-guide-icon-communicate.d498b013.svg";